import { shopItems } from '../../../mocks/shopItems';

const ShopSection = () => (
  <section id="shop" className="w-full bg-[#111111] py-24">
    <div className="max-w-7xl mx-auto px-6">
      {/* Section Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
        <div className="flex items-center gap-4">
          <div className="w-1 h-8 bg-[#f5a623] rounded-full" />
          <div>
            <p className="text-[#f5a623] text-xs font-['Roboto'] font-bold tracking-[4px] uppercase mb-1">
              Merch Store
            </p>
            <h2 className="font-['Bebas_Neue'] text-5xl text-white tracking-wider">
              THE SHOP
            </h2>
          </div>
        </div>
        <p className="text-[#9a9a9a] text-sm font-['Roboto'] max-w-sm">
          Gear for people who work with their hands and drink with intention.
        </p>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
        {shopItems.map((item) => (
          <div
            key={item.id}
            className="group bg-[#1c1c1c] rounded-xl overflow-hidden border border-[#2a2a2a] hover:border-[#f5a623]/40 transition-all duration-300 flex flex-col"
          >
            {/* Image */}
            <div className="relative w-full h-56 overflow-hidden bg-[#222222]">
              <img
                src={item.imageUrl}
                alt={item.name}
                title={`${item.name} – Beer After Work Merch`}
                className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
              />
              {item.badge && (
                <span className="absolute top-3 left-3 bg-[#f5a623] text-black text-xs font-['Roboto'] font-bold px-2 py-1 rounded-md whitespace-nowrap">
                  {item.badge}
                </span>
              )}
            </div>

            {/* Info */}
            <div className="p-5 flex flex-col flex-1 gap-3">
              <h3 className="text-white font-['Roboto'] font-bold text-sm leading-snug">{item.name}</h3>
              <p className="text-[#9a9a9a] text-xs font-['Roboto'] leading-relaxed flex-1">{item.description}</p>

              <div className="flex items-center justify-between pt-2 border-t border-[#2a2a2a]">
                <span className="text-[#f5a623] font-['Bebas_Neue'] text-xl tracking-wider">{item.price}</span>
                <button className="flex items-center gap-1.5 bg-[#f5a623]/10 hover:bg-[#f5a623] border border-[#f5a623]/30 hover:border-[#f5a623] text-[#f5a623] hover:text-black text-xs font-['Roboto'] font-bold px-3 py-2 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shopping-bag-line text-xs" />
                  </div>
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* View All Button */}
      <div className="mt-10 flex justify-center">
        <button className="flex items-center gap-2 border border-[#333333] hover:border-[#f5a623] text-[#9a9a9a] hover:text-[#f5a623] font-['Roboto'] font-bold text-xs tracking-[2px] uppercase px-8 py-3 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap">
          View All Gear
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </div>
        </button>
      </div>
    </div>
  </section>
);

export default ShopSection;
